import { setPageTitle } from 'utils/misc'
import { UserIsAuthenticated, UserHasValidPassword, UserHasScope, UserHasFeatures } from 'containers/authContainers'
import LockRedirect from 'containers/lockContainers'
import { resetInstrument } from '../../modules/Instrument'
import { diaryActions } from '../EditDiary/modules/Diary'
import CreateDiaryView from '../EditDiary/containers/DiaryContainer'
import { fetchCohorts } from '../../../../../Participants/routes/ParticipantsPage/modules/Participants'
import { hasSchedulingEngineFeature } from 'utils/studyConfigUtils'

export default store => ({
  path: 'creatediary',
  exact: true,
  getComponent(nextState, cb) {
    require.ensure(
      [],
      () => {
        const { params } = nextState
        const { studyID, studyVersionID } = params
        const { currentStudy } = store.getState().study
        setPageTitle(`Create Participant Instrument | Study ${studyID} | ${currentStudy.platform_name}`)
        const title = store.getState().instruments ? store.getState().instruments.wizardTitle : ''
        const displayName = store.getState().instruments ? store.getState().instruments.wizardDisplayName : ''
        const hasSchedulingEngine = hasSchedulingEngineFeature(currentStudy)
        store.dispatch(diaryActions.initializeBlankDiary(title, displayName, hasSchedulingEngine))
        store.dispatch(resetInstrument('EDIARY', hasSchedulingEngine))
        store.dispatch(fetchCohorts(nextState.params.studyID))

        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              LockRedirect(
                studyID,
                studyVersionID,
                'instruments',
              )(UserHasScope(['wa'], UserHasFeatures(CreateDiaryView, ['ediary'], 'instruments'), false, studyID)),
            ),
          ),
        )
      },
      'creatediary',
    )
  },
})
